(function () {
  if (window.PremiumLanding) return;

  const state = {
    lenis: null,
    rafId: null
  };

  function initSmoothScroll() {
    if (state.lenis || typeof window.Lenis !== 'function') return;

    state.lenis = new window.Lenis({
      duration: 0.8,
      smoothWheel: true,
      smoothTouch: false,
      wheelMultiplier: 0.92,
      touchMultiplier: 1.05
    });

    if (window.ScrollTrigger) {
      state.lenis.on('scroll', window.ScrollTrigger.update);
    }

    const raf = function (time) {
      state.lenis.raf(time);
      state.rafId = window.requestAnimationFrame(raf);
    };

    state.rafId = window.requestAnimationFrame(raf);
  }

  function initCarousels(root) {
    root.querySelectorAll('[data-premium-carousel]').forEach(function (carousel) {
      if (carousel.dataset.carouselReady === 'true') return;
      carousel.dataset.carouselReady = 'true';

      const track = carousel.querySelector('[data-carousel-track]');
      const prev = carousel.querySelector('[data-carousel-prev]');
      const next = carousel.querySelector('[data-carousel-next]');

      if (!track) return;

      const scrollStep = function () {
        const firstCard = track.querySelector('[data-carousel-card]');
        return firstCard ? firstCard.getBoundingClientRect().width + 24 : track.clientWidth * 0.82;
      };

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: scrollStep(), behavior: 'smooth' });
        });
      }

      let pressed = false;
      let startX = 0;
      let startScroll = 0;

      track.addEventListener('pointerdown', function (event) {
        pressed = true;
        startX = event.clientX;
        startScroll = track.scrollLeft;
        track.setPointerCapture(event.pointerId);
        track.classList.add('is-dragging');
      });

      track.addEventListener('pointermove', function (event) {
        if (!pressed) return;
        track.scrollLeft = startScroll - (event.clientX - startX);
      });

      var release = function (event) {
        if (!pressed) return;
        pressed = false;
        track.classList.remove('is-dragging');
        if (event && track.hasPointerCapture(event.pointerId)) {
          track.releasePointerCapture(event.pointerId);
        }
      };

      track.addEventListener('pointerup', release);
      track.addEventListener('pointercancel', release);
      track.addEventListener('pointerleave', release);
    });
  }

  function initScope(root) {
    initSmoothScroll();
    initCarousels(root);
  }

  window.PremiumLanding = {
    initScope: initScope
  };

  document.addEventListener('DOMContentLoaded', function () {
    initScope(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initScope(event.target);
  });
})();